"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TherapistTrainingListResponseSchema = exports.TherapistTrainingItemSchema = exports.TherapistOfficeDistrictsResponseSchema = exports.TherapistOfficeDistrictItemSchema = exports.TherapistOfficeDistrictClinicSchema = exports.TherapistOfficeDistrictsRequestSchema = exports.TherapistIdResponseSchema = exports.TherapistIdParamsSchema = exports.TherapistMeResponseSchema = exports.TherapistDetailResponseSchema = exports.TherapistDetailParamsSchema = exports.TherapistOfficeResponseSchema = exports.TherapistOfficeRequestSchema = exports.TherapistUpdateRequestSchema = exports.TherapistAvailableAtTimesResponseSchema = exports.TherapistAvailableAtTimesRequestSchema = exports.TherapistListOpenResponseSchema = exports.TherapistListResponseSchema = exports.TherapistListRequestSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("../../../common");
const therapistOffice_1 = require("../../../modules/therapist/therapistOffice");
const therapist_1 = require("../../../modules/therapist/therapist");
exports.TherapistListRequestSchema = therapist_1.TherapistListFilterSchema;
exports.TherapistListResponseSchema = zod_1.z.array(therapist_1.TherapistListItemSchema);
exports.TherapistListOpenResponseSchema = zod_1.z.array(therapist_1.TherapistListOpenItemSchema);
exports.TherapistAvailableAtTimesRequestSchema = zod_1.z.object({
    serviceId: common_1.NumericIdSchema,
    ...therapist_1.TherapistListFilterAvailableAtTimesSchema.shape,
});
exports.TherapistAvailableAtTimesResponseSchema = zod_1.z.array(therapist_1.TherapistListItemSchema);
exports.TherapistUpdateRequestSchema = therapist_1.TherapistBaseSchema.pick({
    visible: true,
    hasOfflineTherapy: true,
    bookingWindowHours: true,
})
    .partial()
    .extend({ aiTranscriptEnabled: therapist_1.TherapistDetailSchema.shape.aiTranscriptEnabled });
exports.TherapistOfficeRequestSchema = therapistOffice_1.TherapistOfficeSchema.omit({
    location: true,
})
    .extend({
    location: zod_1.z.object({
        ...therapistOffice_1.TherapistOfficeLocationSchema.shape,
        googleMapsPlaceTypes: zod_1.z.array(therapistOffice_1.GoogleMapsPlaceTypeItemSchema).default([]),
    }),
})
    .partial();
exports.TherapistOfficeResponseSchema = zod_1.z.object({
    id: common_1.NumericIdSchema,
    therapistId: common_1.NumericIdSchema,
    ...therapistOffice_1.TherapistOfficeSchema.shape,
    createdAt: common_1.DateTimeStringSchema,
    updatedAt: common_1.DateTimeStringSchema,
});
exports.TherapistDetailParamsSchema = zod_1.z.object({
    therapistUserId: zod_1.z.string().regex(/^\d+$/, 'Must be a numeric string').transform(Number),
});
exports.TherapistDetailResponseSchema = therapist_1.TherapistDetailSchema;
exports.TherapistMeResponseSchema = therapist_1.TherapistDetailPrivateSchema;
exports.TherapistIdParamsSchema = zod_1.z.object({
    therapistId: zod_1.z.string().regex(/^\d+$/, 'Must be a numeric string').transform(Number),
});
exports.TherapistIdResponseSchema = therapist_1.TherapistDetailPublicSchema;
exports.TherapistOfficeDistrictsRequestSchema = zod_1.z.object({
    serviceId: common_1.CoercedNumericIdSchema,
});
exports.TherapistOfficeDistrictClinicSchema = zod_1.z.object({
    id: common_1.NumericIdSchema,
    name: zod_1.z.string(),
    address: zod_1.z.string(),
});
exports.TherapistOfficeDistrictItemSchema = zod_1.z.object({
    id: common_1.NumericIdSchema,
    countryCode: zod_1.z.string(),
    regionName: zod_1.z.string(),
    districtName: zod_1.z.string(),
    frequent: zod_1.z.literal(true).optional(),
    clinic: exports.TherapistOfficeDistrictClinicSchema.optional().openapi({
        description: 'sent only for the office district of a clinic',
    }),
});
exports.TherapistOfficeDistrictsResponseSchema = zod_1.z.array(exports.TherapistOfficeDistrictItemSchema);
exports.TherapistTrainingItemSchema = zod_1.z.object({
    id: common_1.NumericIdSchema,
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
});
exports.TherapistTrainingListResponseSchema = zod_1.z.array(exports.TherapistTrainingItemSchema);
